import { ReactNode } from 'react';
import { usePageTransition } from '@/hooks/usePageTransition';

interface PageTransitionProps {
  children: ReactNode;
}

/**
 * Wrapper component that adds page transition effects
 * Shows a loading overlay when navigating between pages
 */
export const PageTransition = ({ children }: PageTransitionProps) => {
  const isTransitioning = usePageTransition();

  return (
    <>
      {isTransitioning && (
        <div className="fixed inset-0 bg-background z-50 flex items-center justify-center animate-fade-in">
          <div className="space-y-4 text-center">
            <div className="inline-flex items-center space-x-2">
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
              <div className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
            </div>
            <p className="text-sm text-muted-foreground">Loading...</p>
          </div>
        </div>
      )}
      <div className={isTransitioning ? 'opacity-0' : 'opacity-100 transition-opacity duration-300'}>
        {children}
      </div>
    </>
  );
};

export default PageTransition;
